import { call, put, select } from 'redux-saga/effects';
import CallSession from '../../../models/CallSession';
import { selectContact } from "../../../state/contact/contactSlice";
import { acceptCallSaga } from '../acceptCall/acceptCall';
import { addCallSessionSaga } from '../../callSessions/addCallSession/addCallSession';
import { selectCrmEnabled } from '../../../state/config/configSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { selectMaxActiveCalls, selectActiveCallCount } from '../../../state/callSessions/callSessionsSlice';
import { selectIncomingCalls, setIncomingCalls, selectDoNotDisturb } from "../../../state/userAgent/userAgentSlice"
import { lookupCrmContactAction } from '../../integration/lookupCrmContact/action';
import { getDisplayName } from "../../../utils/contactUtils";
import { formatPhone, normalizeNumber, isExternalNumber } from '../../../utils/phoneUtils';
import { showCallNotification } from '../../../browser/notifications';

export function* onInviteSaga({ payload: invitation }) {
    const activeCallCount = yield select(selectActiveCallCount)
    const maxCallCount = yield select(selectMaxActiveCalls)
    const doNotDisturb = yield select(selectDoNotDisturb);
    const { contact } = yield select(selectContact);
    const crmEnabled = yield select(selectCrmEnabled);
    const { defaultCrm } = yield select(selectUserCredentials);

    if (activeCallCount >= maxCallCount) {
        return;
    }
    const incomingSession = invitation;
    const callerNumber = incomingSession.remoteIdentity.uri.user.replace(/[^0-9*#]/g, '')
    const isIncomingConference = incomingSession.remoteIdentity.uri.user.includes('adhoc')

    const callSession = new CallSession({
        direction: 'incoming',
        id: incomingSession.id,
        number: callerNumber,
        session: incomingSession,
        status: 'incomingProgressing',
        isOnHold: false,
        isMuted: false,
        isConference: isIncomingConference,
        from_tag: incomingSession.fromTag || incomingSession.request.fromTag

    })

    // CRM Lookup
    if (isExternalNumber(callerNumber) && crmEnabled && defaultCrm) {
        yield put(lookupCrmContactAction({
            crm: defaultCrm,
            phone: normalizeNumber(callerNumber),
            sessionId: callSession.id
        }));
    }

    if (isIncomingConference) {
        callSession.displayName = 'Conference Call';
        yield call(acceptCallSaga, { payload: callSession })
    } else {
        const sessionDisplayName = incomingSession.remoteIdentity.displayName;
        const contactDisplayName = getDisplayName(contact, callerNumber);

        callSession.displayName = sessionDisplayName
        if (contactDisplayName !== callerNumber && sessionDisplayName !== contactDisplayName) {
            callSession.displayName = contactDisplayName;

        }
    }

    yield call(addCallSessionSaga, { payload: callSession }) // add incoming call session to sessions array

    if (doNotDisturb) {
        //Ignoring Calls as DND is on
        callSession.ignore();
        return;
    }

    // Trigger call notification
    showCallNotification({
        id: callSession.id,
        displayName: callSession.displayName,
        number: formatPhone(callSession.number)
    });
    // add incoming call to incomingCalls array to trigger Incoming Call Modal
    const incomingCalls = yield select(selectIncomingCalls);
    yield put(setIncomingCalls([...incomingCalls, callSession]));


}